<div class="social-links">
  <a
    href="https://www.facebook.com/vankitapp"
    target="_blank"
    class="no-external-icon"
  >
    <ion-icon name="logo-facebook"></ion-icon>
  </a>
  <a
    href="https://instagram.com/vankitapp"
    target="_blank"
    class="no-external-icon"
  >
    <ion-icon name="logo-instagram"></ion-icon>
  </a>
  <a href="https://x.com/VanKitApp" target="_blank" class="no-external-icon">
    <ion-icon name="logo-x"></ion-icon>
  </a>
  <a
    href="https://www.tiktok.com/@vankitapp "
    target="_blank"
    class="no-external-icon"
  >
    <ion-icon name="logo-tiktok"></ion-icon>
  </a>
  <a
    href="https://www.youtube.com/@VanKitApp"
    target="_blank"
    class="no-external-icon"
  >
    <ion-icon name="logo-youtube"></ion-icon>
  </a>
</div>
